import React from 'react';
import API from 'shared/constants/api';
import Layout from 'desktop/components/Layout';
import { getSeoTextQuery } from 'shared/helpers/seoText';
import getSpareRouteParams from 'shared/routes/spareparts';
import { setTargetingArguments, directSetSeoText } from 'shared/actions/globals';
import COUNT_URL_PARAMS from 'shared/constants/json/seoText/countUrlParams.json';

import AutoParts from './Spareparts';

async function action(params) {
  const { store, fetch, baseUrl, path } = params;
  const pageParams = await getSpareRouteParams(params);
  if (!pageParams) {
    return null;
  }

  const {
    queryParams,
    transportType,
    currentPage,
    url,
    title,
    description,
    metaHeader,
    isLastPage,
    linkPrefix,
    targetingArguments,
    characteristics,
    canonicalList,
    seoQuery,
    rubricsLinks,
  } = pageParams;

  store.dispatch(setTargetingArguments(targetingArguments));

  // start seoText logic
  const { globals } = store.getState();
  const { locale } = globals;

  const isUk = locale === 'uk';
  const seoTextQuery = getSeoTextQuery(baseUrl, path, isUk, COUNT_URL_PARAMS.katalog);

  const seoText = await fetch(API.SEO.SEARCH_TEXT(seoTextQuery))
    .then(res => res.json())
    .then(response => (response.err ? null : response));
  store.dispatch(directSetSeoText(seoText));
  // end seoText logic

  return {
    chunks: ['auto-parts'],
    title,
    page: currentPage,
    isLastPage,
    routeName: 'auto-parts',
    description,
    shouldSetNoIndex: false,
    shouldSetIndex: true,
    component: (
      <Layout withBranding>
        <AutoParts
          queryParams={queryParams}
          transportType={transportType}
          currentPage={currentPage}
          url={url}
          query={seoQuery}
          title={metaHeader}
          linkPrefix={linkPrefix}
          canonicalList={canonicalList}
          rubricsLinks={rubricsLinks}
          seoCharacteristics={characteristics}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/index.js